import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { firmaDigitalRoutesMap } from './firmaDigitalRoutesMap'

const AppFirmaDigital = Loadable(lazy(() => import('./view/listado/FirmaDigital')))

const firmaDigitalRoutes = [
  {
    path: firmaDigitalRoutesMap.gestion.path,
    element: <AppFirmaDigital />,
    auth: authRoles.admin,
  },
]

export default firmaDigitalRoutes
